module.exports = __webpack_public_path__ + "img/Archery.9ec7a0f3.png";